import React, { createContext, useContext, useState, useEffect } from "react";
import { allowsCategory } from "../util/cookieConsent";
import { BRAND } from "../brand";

const ThemeContext = createContext();
const BRAND_DEFAULT_THEME = BRAND.id === "condense" ? "dark" : "light";

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (allowsCategory("functional")) {
      return localStorage.getItem("theme") || BRAND_DEFAULT_THEME;
    }
    return BRAND_DEFAULT_THEME;
  });

  useEffect(() => {
    document.documentElement.classList.remove("light", "dark");
    document.documentElement.classList.add(theme);
    if (allowsCategory("functional")) {
      localStorage.setItem("theme", theme);
    }
  }, [theme]);

  useEffect(() => {
    const onConsent = () => {
      if (!allowsCategory("functional") && theme !== BRAND_DEFAULT_THEME) {
        setTheme(BRAND_DEFAULT_THEME);
      }
    };
    window.addEventListener("wv:cookie-consent", onConsent);
    return () => window.removeEventListener("wv:cookie-consent", onConsent);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
